import styled from 'styled-components';
import { Heading as MaestroHeading, Box } from '@landr/maestro';

export const Heading = styled(MaestroHeading)`
    user-select: none;
`;

export const UppercaseHeading = styled(Heading)`
    text-transform: uppercase;
`;

export const ArtworksWrapper = styled(Box)`
    width: 630px;
    max-width: 60%;

    ${({ theme }): string => theme.breakpoint('md')`
        width: 100%;
        max-width: 360px;
    `}
`;
